export default function truncateTextForHTMLDisplay(
  text,
  length,
  suffix = " ..."
) {
  if (!text) return "";
  return text.substring(0, length) + suffix;
}
